/**
 * Nossos Fundos Filter
 * Gerencia pills de tipo (desktop), select de tipo (mobile),
 * selects de visualização e operadora.
 * Dispatcha 'nossos-fundos-filter:change' quando qualquer filtro muda.
 */
export function initNossosFundosFilter() {
  const wrapper = document.querySelector('.nossos-fundos-filter');
  if (!wrapper) return;

  const pillsEl    = wrapper.querySelector('.nossos-fundos-filter__pills[data-filter="tipo"]');
  const tipoMobile = wrapper.querySelector('.nossos-fundos-filter__select--tipo[data-filter="tipo-mobile"]');
  const otherSelects = wrapper.querySelectorAll(
    '.nossos-fundos-filter__select:not(.nossos-fundos-filter__select--tipo)'
  );

  const state = {
    tipo:         pillsEl?.querySelector('.nossos-fundos-filter__pill.is-active')?.dataset.value ?? '',
    visualizacao: '',
    operadora:    '',
  };

  // ── Pills (desktop) ────────────────────────────
  if (pillsEl) {
    const pills = pillsEl.querySelectorAll('.nossos-fundos-filter__pill');

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        pills.forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');
        state.tipo = pill.dataset.value ?? '';

        // Sincroniza select mobile
        syncMobileSelect(state.tipo);
        dispatch('tipo', state.tipo);
      });
    });
  }

  // ── Select de tipo (mobile) ────────────────────
  if (tipoMobile) {
    initSelect(tipoMobile, (value) => {
      state.tipo = value;

      // Sincroniza pills
      if (pillsEl) {
        pillsEl.querySelectorAll('.nossos-fundos-filter__pill').forEach(pill => {
          pill.classList.toggle('is-active', pill.dataset.value === value);
        });
      }

      dispatch('tipo', value);
    });
  }

  // ── Outros selects (visualização, operadoras) ──
  otherSelects.forEach(select => {
    const filterName = select.dataset.filter;

    initSelect(select, (value) => {
      if (filterName === 'visualizacao') state.visualizacao = value;
      if (filterName === 'operadora')    state.operadora    = value;
      dispatch(filterName, value);
    });
  });

  // ── Fechar ao clicar fora ──────────────────────
  document.addEventListener('click', () => {
    wrapper.querySelectorAll('.nossos-fundos-filter__select.is-open').forEach(s => {
      s.classList.remove('is-open');
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      wrapper.querySelectorAll('.nossos-fundos-filter__select.is-open').forEach(s => {
        s.classList.remove('is-open');
      });
    }
  });

  // ── Helpers ────────────────────────────────────
  function initSelect(selectEl, onChange) {
    const textEl   = selectEl.querySelector('.nossos-fundos-filter__select-text');
    const dropdown = selectEl.querySelector('.nossos-fundos-filter__dropdown');
    if (!dropdown) return;

    const items = dropdown.querySelectorAll('.nossos-fundos-filter__dropdown-item');

    selectEl.addEventListener('click', (e) => {
      if (dropdown.contains(e.target)) return;
      e.stopPropagation();

      // Fecha outros selects abertos
      wrapper.querySelectorAll('.nossos-fundos-filter__select.is-open').forEach(s => {
        if (s !== selectEl) s.classList.remove('is-open');
      });

      selectEl.classList.toggle('is-open');
    });

    items.forEach(item => {
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        items.forEach(i => i.classList.remove('is-active'));
        item.classList.add('is-active');
        if (textEl) textEl.textContent = item.textContent.trim();
        selectEl.classList.remove('is-open');
        onChange?.(item.dataset.value ?? '', item.textContent.trim());
      });
    });
  }

  function syncMobileSelect(value) {
    if (!tipoMobile) return;
    const textEl = tipoMobile.querySelector('.nossos-fundos-filter__select-text');
    const items  = tipoMobile.querySelectorAll('.nossos-fundos-filter__dropdown-item');

    items.forEach(item => {
      const isMatch = item.dataset.value === value;
      item.classList.toggle('is-active', isMatch);
      if (isMatch && textEl) textEl.textContent = item.textContent.trim();
    });
  }

  function dispatch(filter, value) {
    if (filter === 'tipo') {
      wrapper.querySelectorAll('.nossos-fundos-filter__nota-tipo').forEach(el => {
        el.hidden = el.dataset.notaTipo !== value;
      });
    }

    wrapper.dispatchEvent(new CustomEvent('nossos-fundos-filter:change', {
      detail: { filter, value, state: { ...state } },
      bubbles: true,
    }));
  }
}
